import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Javascript debugging [slightly] beyond console.log",
  "description": "",
  "published": "2015-01-14T00:00:00.000Z",
  "redirect_from": ["/blog/javascript-debugging-slightly-beyond-console-log/swizec/6633"],
  "categories": "Apache Hadoop, Cascading Style Sheets, Debugging, HTML, JavaScript, Technical",
  "hero": "./img/images-25871.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e6c3a387168d135990f8d11798c2b824/b4cdf/images-25871.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.677130044843054%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'255\\'%20viewBox=\\'0%200%20400%20255\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2097v97h401V97a2405%202405%200%2000-3-95h-1l1%202%202%201-15%201h-16V0H0v97M176%205v3h50V2h-50v3M85%2044c0%202%200%202-5%202s-5%200-5%203c0%202%200%202-2%202-3%200-3%200-3%205%200%202%200%203%201%202%200-2%201-2%205-2s4%200%204-2c0-3%200-3%205-3s5-1%205-3%200-2%205-2%205-1%206-3c0-2-1-2-8-2-8%200-8%200-8%203m213%200c0%202%201%202%205%202%203%200%204%200%204%202s1%203%206%203c4%200%205%201%205%203%200%201%200%202%202%202s3%200%203-2l2-2c2%200%202%200%200-1-2%200-2-1-2-3s-1-2-6-2-5%200-5-2c0-3%200-3-7-3-8%200-8%200-7%203M75%2073v13h3c2%200%202%200%202%208s0%208%202%208%203%201%203%203%201%203%203%203c3%200%203%203-1%203l2%201%208%201h3V95l1-18h-6c-5%200-5%200-5-2%200-3%200-3-5-3s-6-1-6-3l-1-3c-1%200-2-1-2-3-1-1-1%203-1%2010m233%201c0%202-1%203-5%203h-5v36h8v18l1%2018v-37h2c3%200%203%200%203-8l1-12%201-5c2%200%202%202%202%208l1%208v-9c0-8%200-8%203-8%202%200%202%200%200-1-2%200-2-1-2-7v-6h-5c-4%200-5%200-5%202M91%20128c0%2010%200%2011%202%2011s2%201%202%205%200%204%202%204c3%200%203%200%203-9v-22h-9v11m207-7c0%204-1%205-3%205-3%200-3%200-3%206%200%205%201%205%203%206s3%201%203%205c0%205%200%205%203%205h2v-15c0-15-1-16-3-16s-2%200-2%204m10%2031v2h35v3c0%202%201%202%203%202s3%201%203%203c1%203%205%204%205%200v-3l-1-2c0-2%200-3-2-3s-3-1-3-3v-2h-40v3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e6c3a387168d135990f8d11798c2b824/ca0a1/images-25871.webp 223w", "/static/e6c3a387168d135990f8d11798c2b824/75680/images-25871.webp 445w", "/static/e6c3a387168d135990f8d11798c2b824/8d1ba/images-25871.webp 890w", "/static/e6c3a387168d135990f8d11798c2b824/3838e/images-25871.webp 1335w", "/static/e6c3a387168d135990f8d11798c2b824/3f641/images-25871.webp 1417w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e6c3a387168d135990f8d11798c2b824/e92b6/images-25871.png 223w", "/static/e6c3a387168d135990f8d11798c2b824/e66bf/images-25871.png 445w", "/static/e6c3a387168d135990f8d11798c2b824/4ef49/images-25871.png 890w", "/static/e6c3a387168d135990f8d11798c2b824/4e814/images-25871.png 1335w", "/static/e6c3a387168d135990f8d11798c2b824/b4cdf/images-25871.png 1417w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e6c3a387168d135990f8d11798c2b824/4ef49/images-25871.png",
                "alt": "debugger;",
                "title": "debugger;",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`debugger;`}</figcaption>{`
  `}</figure></p>
    <p>{`My favourite tool for javascript debugging is `}<inlineCode parentName="p">{`console.log`}</inlineCode>{`.`}</p>
    <p>{`I mean, I `}<em parentName="p">{`love`}</em>{` `}<inlineCode parentName="p">{`console.log`}</inlineCode>{`. If I ever get a programming tattoo, it's going to be `}<inlineCode parentName="p">{`console.log`}</inlineCode>{` or some variation thereof. Simple to use, works every time, and every programming language I've used since I was 9 has had some variation of it.`}</p>
    <p><a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Pascal_%28programming_language%29",
        "title": "Pascal (programming language)"
      }}>{`Pascal`}</a>{` acting up? Not sure what's going on? `}<inlineCode parentName="p">{`writeln`}</inlineCode></p>
    <p><a parentName="p" {...{
        "href": "http://www.python.org/",
        "title": "Python (programming language)"
      }}>{`Python`}</a>{` being silly? `}<inlineCode parentName="p">{`print`}</inlineCode></p>
    <p>{`C acting funny? `}<inlineCode parentName="p">{`printf`}</inlineCode></p>
    <p><a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Cascading_Style_Sheets",
        "title": "Cascading Style Sheets"
      }}>{`CSS`}</a>{` weird? `}<inlineCode parentName="p">{`border: 1px solid red`}</inlineCode></p>
    <p><a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/HTML",
        "title": "HTML"
      }}>{`HTML`}</a>{` messing with you? Nah, `}<a parentName="p" {...{
        "href": "http://www.google.com/chrome",
        "title": "Google Chrome"
      }}>{`Chrome`}</a>{`'s element inspector.`}</p>
    <p>{`But as much as I love `}<inlineCode parentName="p">{`console.log`}</inlineCode>{`, sometimes it just does not do. Sure, if you have a proper test suite `}<inlineCode parentName="p">{`console.log`}</inlineCode>{` is always enough. But you don't always have a proper test suite.`}</p>
    <p>{`Let me explain.`}</p>
    <p>{`When you want to understand what's going on and where exactly a piece of code goes wrong, you do something like this.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var do_something = function (arg1) {
  console.log("got into function", arg1);
  var foo = get_my_foo(arg1);
  do_another_thing();
  console.log("foo changed?", foo);
  return foo;
};
`}</code></pre>
    <p>{`Not the prettiest. But it works. You can tell what's going on.`}</p>
    <p>{`You know for certain the function was called, what the argument value was, and you know the value of `}<inlineCode parentName="p">{`foo`}</inlineCode>{` when it returns.`}</p>
    <p>{`Perfect for calling the code once. But what if it's part of a list building mechanism?`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`a_lot_of_things.map(function (thing) {
  var label = do_something(thing);
  $("ul").append($("<li></li>").html(label));
});
`}</code></pre>
    <p>{`Wellp, now you've got a bunch of console output to look through. Annoying, but manageable. You can still tell which argument produces which output.`}</p>
    <p>{`But we're stretching the limits of `}<inlineCode parentName="p">{`console.log`}</inlineCode>{` here.`}</p>
    <p>{`Now what if somebody does this?`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`async.map(a_lot_of_things, function (thing) {
  var label = do_something(thing);
  $("ul").append($("<li></li>").html(label));
});
`}</code></pre>
    <p>{`Wow, that's annoying. Your `}<inlineCode parentName="p">{`do_something`}</inlineCode>{` function is called asynchronously. The output is all jumbled up!`}</p>
    <p>{`Very annoying. But you can map input to output in your mind. They're both printed right next to each other.`}</p>
    <p>{`It's just harder because you have to read the whole output every time and can't jump to the line you're interested in. The problem is ALWAYS with just one of the elements. Obviously.`}</p>
    <p>{`Wow, we're really stretching that `}<inlineCode parentName="p">{`console.log`}</inlineCode>{`. Let's break it.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var do_something = function (arg1, callback) {
  console.log("got into function", arg1);
  var foo = get_my_foo(arg1);
  setTimeout(function () {
    do_another_thing();
    console.log("foo changed?", foo);
    callback(foo);
  }, 100);
};

async.map(a_lot_of_things, function (thing) {
  do_something(thing, function (label) {
    $("ul").append($("<li></li>").html(label));
  });
});
`}</code></pre>
    <p>{`You wouldn't just spray `}<inlineCode parentName="p">{`setTimeout`}</inlineCode>{`s in your code like that. But now you have an asynchronous function. Maybe it's an Angular watch, you're responding to a promise, or something.`}</p>
    <p>{`Point is, all of your `}<inlineCode parentName="p">{`console.log`}</inlineCode>{` outputs are now jumbled up and useless. Something like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`got into function, foo1 got into function, foo3 foo changed?, yes got into
function, foo2 foo changed?, no got into function, foo4 got into function, foo5
foo changed?, yes foo changed?, no foo changed?, yes
`}</code></pre>
    <p>{`Wow, talk about useless!`}</p>
    <p>{`When faced with a situation like this, I would start adding `}<inlineCode parentName="p">{`alert()`}</inlineCode>{`s to my code. It stops execution and lets you look at the output in a particular moment.`}</p>
    <p>{`But it blocks the entire browser, you can't look around much, and clicking all those pop ups is annoying as hell. Especially once you've found the culprit, but can't just refresh the page.`}</p>
    <p><inlineCode parentName="p">{`alert()`}</inlineCode>{` disables Cmd+R because it steals focus from the window. You `}<em parentName="p">{`have to`}</em>{` get to the end of the loop before you can stop it.`}</p>
    <p>{`:(`}</p>
    <p>{`A few weeks ago I stumbled onto a better way through someone's throwaway comment. `}<inlineCode parentName="p">{`debugger;`}</inlineCode></p>
    <p>{`It. Is. Magic.`}</p>
    <p>{`Instead of that second print statement, `}<inlineCode parentName="p">{`console.log("foo changed?", foo)`}</inlineCode>{`, we'd put `}<inlineCode parentName="p">{`debugger;`}</inlineCode>{`. When Chrome, and other modern browsers?, sees that statement, it stops.`}</p>
    <p>{`But it doesn't just stop. It gives you a debugger.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e6c3a387168d135990f8d11798c2b824/b4cdf/images-25868.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.677130044843054%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'255\\'%20viewBox=\\'0%200%20400%20255\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2097v97h401V97a2405%202405%200%2000-3-95h-1l1%202%202%201-15%201h-16V0H0v97M176%205v3h50V2h-50v3M85%2044c0%202%200%202-5%202s-5%200-5%203c0%202%200%202-2%202-3%200-3%200-3%205%200%202%200%203%201%202%200-2%201-2%205-2s4%200%204-2c0-3%200-3%205-3s5-1%205-3%200-2%205-2%205-1%206-3c0-2-1-2-8-2-8%200-8%200-8%203m213%200c0%202%201%202%205%202%203%200%204%200%204%202s1%203%206%203c4%200%205%201%205%203%200%201%200%202%202%202s3%200%203-2l2-2c2%200%202%200%200-1-2%200-2-1-2-3s-1-2-6-2-5%200-5-2c0-3%200-3-7-3-8%200-8%200-7%203M75%2073v13h3c2%200%202%200%202%208s0%208%202%208%203%201%203%203%201%203%203%203c3%200%203%203-1%203l2%201%208%201h3V95l1-18h-6c-5%200-5%200-5-2%200-3%200-3-5-3s-6-1-6-3l-1-3c-1%200-2-1-2-3-1-1-1%203-1%2010m233%201c0%202-1%203-5%203h-5v36h8v18l1%2018v-37h2c3%200%203%200%203-8l1-12%201-5c2%200%202%202%202%208l1%208v-9c0-8%200-8%203-8%202%200%202%200%200-1-2%200-2-1-2-7v-6h-5c-4%200-5%200-5%202M91%20128c0%2010%200%2011%202%2011s2%201%202%205%200%204%202%204c3%200%203%200%203-9v-22h-9v11m207-7c0%204-1%205-3%205-3%200-3%200-3%206%200%205%201%205%203%206s3%201%203%205c0%205%200%205%203%205h2v-15c0-15-1-16-3-16s-2%200-2%204m10%2031v2h35v3c0%202%201%202%203%202s3%201%203%203c1%203%205%204%205%200v-3l-1-2c0-2%200-3-2-3s-3-1-3-3v-2h-40v3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e6c3a387168d135990f8d11798c2b824/ca0a1/images-25868.webp 223w", "/static/e6c3a387168d135990f8d11798c2b824/75680/images-25868.webp 445w", "/static/e6c3a387168d135990f8d11798c2b824/8d1ba/images-25868.webp 890w", "/static/e6c3a387168d135990f8d11798c2b824/3838e/images-25868.webp 1335w", "/static/e6c3a387168d135990f8d11798c2b824/3f641/images-25868.webp 1417w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e6c3a387168d135990f8d11798c2b824/e92b6/images-25868.png 223w", "/static/e6c3a387168d135990f8d11798c2b824/e66bf/images-25868.png 445w", "/static/e6c3a387168d135990f8d11798c2b824/4ef49/images-25868.png 890w", "/static/e6c3a387168d135990f8d11798c2b824/4e814/images-25868.png 1335w", "/static/e6c3a387168d135990f8d11798c2b824/b4cdf/images-25868.png 1417w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e6c3a387168d135990f8d11798c2b824/4ef49/images-25868.png",
                "alt": "The debugger, initial view",
                "title": "The debugger, initial view",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`The debugger, initial view`}</figcaption>{`
  `}</figure></p>
    <p>{`You can't see it in the screenshot, but even `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Graphics_Interchange_Format",
        "title": "Graphics Interchange Format"
      }}>{`GIFs`}</a>{` are stopped. A moment ago that Santa was dancing, now everything is in `}<em parentName="p">{`"Holy shit, he's debugging!"`}</em>{` mode.`}</p>
    <p>{`The code that triggered `}<inlineCode parentName="p">{`debugger;`}</inlineCode>{` is in the middle. A bunch of inspection tools are on the right. On top of the screen is an `}<em parentName="p">{`"I'm done now, please continue"`}</em>{` button.`}</p>
    <p>{`But more importantly, the console is in current scope! You can do whatever you want.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/4abb2a275fb52ad3f08209b95c30ee70/c4b7c/images-25870.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "33.6322869955157%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'134\\'%20viewBox=\\'0%200%20400%20134\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%209v8h401V0H0v9\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4abb2a275fb52ad3f08209b95c30ee70/ca0a1/images-25870.webp 223w", "/static/4abb2a275fb52ad3f08209b95c30ee70/75680/images-25870.webp 445w", "/static/4abb2a275fb52ad3f08209b95c30ee70/8d1ba/images-25870.webp 890w", "/static/4abb2a275fb52ad3f08209b95c30ee70/4673f/images-25870.webp 903w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4abb2a275fb52ad3f08209b95c30ee70/e92b6/images-25870.png 223w", "/static/4abb2a275fb52ad3f08209b95c30ee70/e66bf/images-25870.png 445w", "/static/4abb2a275fb52ad3f08209b95c30ee70/4ef49/images-25870.png 890w", "/static/4abb2a275fb52ad3f08209b95c30ee70/c4b7c/images-25870.png 903w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4abb2a275fb52ad3f08209b95c30ee70/4ef49/images-25870.png",
                "alt": "Console is in current scope",
                "title": "Console is in current scope",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Console is in current scope`}</figcaption>{`
  `}</figure></p>
    <p>{`And once you've found the culprit, you can just refresh the page. No waiting for all the `}<inlineCode parentName="p">{`alert()`}</inlineCode>{`s to show up.`}</p>
    <p>{`Now, I'm not going to stop using `}<inlineCode parentName="p">{`console.log`}</inlineCode>{` any time soon. But knowing about `}<inlineCode parentName="p">{`debugger`}</inlineCode>{` has made my life easier many times.`}</p>
    <p>{`I only wish I'd known about it sooner.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      